<template>
    <ac-modal title="Confirm Payment Scheduling" ref="modalRef" :size-class="'modal-lg'" data-keyboard="false" data-backdrop="static">
        <template v-if="widgetReady">
            <div class="row">
                <div class="col-md-12">
                    <p><span style="min-width: 12px;">Date: </span>{{ vm.monthName }} - {{ vm.batchYear }}</p>                    
                    <p style="font-weight: bold!important;">Collect Amount: {{ vm.amount | currency }}</p>
                </div>
            </div><div class="alert alert-warning">
                        <input type="checkbox" class="filled-in" id='debt-ver-check' v-model="memberAgrees">
                        <label for="debt-ver-check" style="text-align: left">
                            <p>Please confirm you would like to schedule this payment for the next payment cycle.<br></p>
                        </label>
                    </div>
            <span >
                Click <router-link :to="{name:'paymentMethod',params:{companyId}}" @click.native="closeModal">here</router-link> to update your current banking information.
            </span>
            <div class="row">
                <div class="col-xs-12">
                    <div class="modal-footer">
                        <div class="button-box">                       
                                <ac-button class="btn btn-sm btn-red" :action="closeModal">CANCEL</ac-button>
                                <ac-button class="btn btn-sm btn-green" :action="collectPayment">PAY</ac-button>                     
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
import { common } from "@/global/common";
import { api } from "@/global/framework/api"
import { mapGetters } from 'vuex';
import { notifications } from "@/global/notifications.js";
import AcButton from "../../../global/customHtmlElements/AcButton.vue";

export default {
    name: "CompanyDebtCollectionModal",
    components: { AcButton },
    data() {
        return {
            vm:null,
            widgetReady: false,
            memberAgrees: false,
            companyId:0,
        };
    },
    methods: {
        async showModal(data) {      
            this.vm = data;
            this.companyId = data.companyId;
            this.widgetReady = true;
            this.$refs.modalRef.open();
        },
        closeModal(status = false) {
            this.$refs.modalRef.close();
            this.$emit("modal-closed", status);
        },
        async collectPayment() {
            let companyHasPaymentInfo = await api.get('Company', this.companyId, 'GetCompanyHasPaymentInfo');      
            if (this.memberAgrees && companyHasPaymentInfo) {
                let result = api.postWithId('Company', this.companyId, 'PayCompanyDebt', this.vm);             
                if (result) this.closeModal(true);
            }
            else {
                notifications.show({ title: "Failure!", message: "Must agree to payment. Must have banking information on file." }, common.ACRESSA_NOTIFICATIONS.ERROR);
            }
        },
    },
}
</script>

<style scoped>
.modal-footer {
    padding-left: 0;
    padding-right: 0;
}
</style>